import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { InstitutionService } from '@lemsar/institution/domains/services/institution.service';
import { Institution } from '@lemsar/institution/domains/model/institution';
import { AuthStore } from '@lemsar/storage/stores/auth.store';
import { Collection } from '@lemsar/common/domains/interface/collection';
import { User } from '@lemsar/auth/domains/models/user';
import { environment } from '../../../../../../environments/environment';
import { filter, switchMap, tap } from 'rxjs/operators';
import { MessageService } from '@lemsar/message/domains/services/message.service';
import { Message } from '@lemsar/message/domains/model/message';
import { Observable } from 'rxjs/Observable';
import { UserService } from '@lemsar/user/domains/services/user.service';
import { RoleType } from '@shared/enum/role-type';

@Component({
    selector: 'lemsar-default-template',
    templateUrl: './default.template.html',
})
export class DefaultTemplate implements OnInit {
    public dialogOpened = false;
    public dialogVerifiedInstitutionOpened = false;
    public action: string;
    public selectedInstitutionId: string;
    public isAdmin: boolean;
    public showInboxDropdown: boolean = false;
    public showSettingDropdown: boolean = false;
    public showPartnerDropdown: boolean = false;
    public unreadMessages: Array<Message> = [];
    public institutions: Collection<Institution>;
    public verifiedInstitutions: Collection<Institution>;
    public createPelatihanUrl = environment.pelatihanUrl + 'institutions/vin-number/';
    public environment = environment;
    public dataMenu: Array<any> = [
        {
            text: 'Lembaga',
            icon: 'fas fa-university',
            click: (dataItem: any) => {
                this.router.navigate(['institutions', 'create']);
            },
        },
        {
            text: 'Workshop',
            icon: 'fas fa-wrench',
            click: (dataItem: any) => {
                this.action = 'buildings/workshops';
                this.dialogOpened = true;
            },
        },
        {
            text: 'Ruang Kelas',
            icon: 'fas fa-coffee',
            click: (dataItem: any) => {
                this.action = 'buildings/classes';
                this.dialogOpened = true;
            },
        },
        {
            text: 'Tempat Uji Kompetensi',
            icon: 'fas fa-trophy',
            click: (dataItem: any) => {
                this.action = 'buildings/competences';
                this.dialogOpened = true;
            },
        },
        {
            text: 'Bangunan Lainnya',
            icon: 'fas fa-building',
            click: (dataItem: any) => {
                this.action = 'buildings/others';
                this.dialogOpened = true;
            },
        },
        {
            text: 'Kejuruan & Program Pelatihan',
            icon: 'fas fa-life-ring',
            click: (dataItem: any) => {
                this.action = 'programs/vocationals';
                this.dialogOpened = true;
            },
        },
        {
            text: 'Realisasi Pelatihan',
            icon: 'fas fa-lightbulb',
            click: (dataItem: any) => {
                this.action = 'programs/trainings';
                this.dialogOpened = true;
            },
        },
    ];
    public user: User | null;
    public auth: any;

    public roleAdmin: string = RoleType.ADMIN;

    public constructor(
        private router: Router,
        private institutionService: InstitutionService,
        private authStore: AuthStore,
        private messageService: MessageService,
    ) {
        this.auth = this.authStore;
    }

    public ngOnInit(): void {
        this.authStore.user$
            .pipe(
                filter(user => !!user),
                tap((user: User) => {
                    if (Object.keys(user).length !== 0) {
                        this.user = user;
                        this.institutionService.fetchInstitutionByUser(user.id).subscribe((data: Collection<Institution>) => {
                            this.institutions = data;
                        });
                        this.institutionService.fetchVerifiedInstitutionByUser(user.id).subscribe((data: Collection<Institution>) => {
                            this.verifiedInstitutions = data;
                        });
                        this.isAdmin = this.authStore.user.hasRole('admin');
                        this.messageService.fetchLatestUnreadMessagesByUser(user.id).subscribe((data: Array<Message>) => {
                            this.unreadMessages = data;
                        });
                    }
                }),
            )
            .subscribe();
    }

    public toInstitution(): void {
        this.router.navigateByUrl('http://kemnaker.go.id/');
    }

    public close(): void {
        this.dialogOpened = false;
    }

    public onItemClick(id: string): void {
        this.selectedInstitutionId = id;
        this.dialogOpened = false;
        this.router.navigateByUrl('/institutions/' + this.selectedInstitutionId + '/' + this.action + '/create');
    }

    public logout(): void {
        this.router.navigateByUrl('/auth/logout');
    }

    public openDialogVerifiedIntitution(): void {
        this.dialogVerifiedInstitutionOpened = true;
    }

    public closeDialogVerifiedIntitution(): void {
        this.dialogVerifiedInstitutionOpened = false;
    }

    public toggleInboxDropdown() {
        this.showInboxDropdown = !this.showInboxDropdown;
    }

    public toggleSettingDropdown() {
        this.showSettingDropdown = !this.showSettingDropdown;
    }

    public togglePartnerDropdown() {
        this.showPartnerDropdown = !this.showPartnerDropdown;
    }

    public get isAdminCity(): boolean {
        if (Object.keys(this.auth.user).length > 0) {
            return this.auth.user.hasRole(this.roleAdmin) && null !== this.auth.user.userable;
        }

        return false;
    }
}



// WEBPACK FOOTER //
// ./apps/frontend/src/template/default/components/default.template.ts